import React from 'react';

import { DayRange } from '../../WidgetBlocks/types';
import DayRangeSelector, { DayRangeSelectorProps } from '../DayRangeSelector';

interface DayRangeFormGroupProps {
    dayRange: DayRange;
    onChange: DayRangeSelectorProps['onChange'];
}

const DayRangeFormGroup: React.FC<DayRangeFormGroupProps> = ({ dayRange: { min, max }, onChange }) => (
    <>
        <div style={{ gridColumn: 1 }}>
            <strong>Day range:</strong>
        </div>
        <div style={{ gridColumn: '2/5', paddingRight: 15 }}>
            <DayRangeSelector onChange={onChange} value={[min, max]} />
        </div>
    </>
);

export default React.memo(DayRangeFormGroup);
